import {  ConfigProvider, Layout as AntdLayout } from 'antd';
import React from 'react';
import MainContent from './MainContent';

export const MainLayout = () => {

  return (
    <AntdLayout style={{ background: 'transparent', margin:'1% 3%'}}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#4094d0',
            fontFamily: 'var(--font-family)'            
          }
        }}>
        <MainContent/>
      </ConfigProvider>
    </AntdLayout>
	)
};

